import sanityClient from "../client";

// Artists come from successStories only.
//
// These used to be merged with `homepageImages`, which was never an artist
// type — it is a caption-and-picture bucket, and one of its documents is a
// long description of the Foundation itself. That document was being turned
// into an "artist" card titled with the first 47 characters of its own body
// text. Every artist now has a real successStories entry instead.
const SUCCESS_QUERY = `*[_type == "successStories"] {
  _id,
  name,
  description,
  achievements,
  mediaLinks,
  displayOrder,
  "images": images[]{
    credit,
    "url": asset->url,
    "alt": asset->originalFilename
  }
}`;

function normalize(item) {
  return {
    _id: item._id,
    name: (item.name || "").trim(),
    description: item.description,
    achievements: item.achievements,
    mediaLinks: item.mediaLinks,
    images: item.images || [],
    displayOrder: item.displayOrder,
  };
}

const hasImage = (s) => s.images.length > 0;

/**
 * Artists with photos lead, then anything with an explicit displayOrder, then
 * alphabetically. Roster entries without a photo are kept rather than dropped
 * — they render with an initials tile until a real photo is uploaded.
 */
function sortStories(list) {
  return [...list].sort(
    (a, b) =>
      Number(hasImage(b)) - Number(hasImage(a)) ||
      (a.displayOrder ?? Number.MAX_SAFE_INTEGER) -
        (b.displayOrder ?? Number.MAX_SAFE_INTEGER) ||
      a.name.localeCompare(b.name)
  );
}

export async function fetchStories() {
  let data = [];
  try {
    data = (await sanityClient.fetch(SUCCESS_QUERY)) || [];
  } catch (err) {
    console.error("Error fetching successStories:", err);
    return [];
  }
  return sortStories(data.map(normalize).filter((s) => s.name));
}

/** DOM id used to anchor/scroll to a specific story card. */
export const storyAnchorId = (id) => `story-${id}`;

/** Initials used for the placeholder tile when an artist has no photo. */
export function initialsOf(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}
